module.exports = __webpack_public_path__ + "static/img/5.33fc226.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/5.png
// module id = ZIMo
// module chunks = 0